export enum MessageType { 
    Error = "Error",
    Info = "Info",
}